import { render, staticRenderFns } from "./VoiceCardView.vue?vue&type=template&id=2d530f0c&scoped=true"
import script from "./VoiceCardView.vue?vue&type=script&lang=ts"
export * from "./VoiceCardView.vue?vue&type=script&lang=ts"
import style0 from "./VoiceCardView.vue?vue&type=style&index=0&id=2d530f0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d530f0c",
  null
  
)

export default component.exports